import { IAddContactRequest } from "@montana/models/generated/cms.interface";
import { staticSettings } from "@montana/helpers/static-settings.helper";
import { createServiceFunction } from "../http";

export const subscribe = createServiceFunction((contact: IAddContactRequest) => {
    const url = `${staticSettings.apiUrl}/api/newsletter/subscribe`;

    return f => f(
        url,
        {
            method: "POST",
            body: JSON.stringify(contact),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
});
